import { render, staticRenderFns } from "./OrganizationRemoveCollaboratorDialog.vue?vue&type=template&id=39982671&scoped=true"
import script from "./OrganizationRemoveCollaboratorDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationRemoveCollaboratorDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationRemoveCollaboratorDialog.vue?vue&type=style&index=0&id=39982671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39982671",
  null
  
)

export default component.exports